module.exports = __webpack_public_path__ + "img/chart.eb557b5d.svg";